module.exports = __webpack_public_path__ + "eeaa37143b983bbd5640115f49b8f759.mp3";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/gewonnen_level_3_opgewekt.mp3
// module id = 96
// module chunks = 0